import { logEvent, setUserProperties, ANALYTICS_EVENTS } from '../services/analytics';

export const useAnalytics = () => {
    return {
        logEvent,
        setUserProperties,
        events: ANALYTICS_EVENTS
    };
};
